import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import backend from "../api";

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState();
  const [instanceLoading, setInstanceLoading] = useState(true);

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        setInstanceLoading(true);
        try {
          const response = await backend.post(
            "/connected-account/account_session",
            {
              account: connectedAccountId,
            }
          );

          if (response.status !== 200) {
            // Handle errors from the server
            throw new Error(
              response.data.error || "Failed to fetch client secret"
            );
          }

          const { client_secret: clientSecret } = response.data;
          return clientSecret;
        } catch (error) {
          console.error(
            "An error occurred while fetching client secret:",
            error
          );
          throw error; // Rethrow for higher-level handling if needed
        } finally {
          setInstanceLoading(false);
        }
      };

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey:
            "pk_test_51Mm4i5BbiNWHJzfiKwdLrGwuhvo9zqQDTsxtKTePi6iliH6VWYL4TEVFB3N3EnnmnGyp3dlldupuIiVsuC8C8F4K00snGFrutv",
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#635BFF",
            },
          },
        })
      );
    }
  }, [connectedAccountId]);

  return { stripeConnectInstance, instanceLoading };
};

export default useStripeConnect;
